import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from "@angular/core";

@Component({
  selector: "search-services",
  templateUrl: "./search-services.component.html",
  styleUrls: ["./search-services.component.scss"],
})
export class SearchServicesComponent implements OnInit, OnChanges {

  @Input() public prependIcon: string = null;
  @Input() public appendIcon: string = null;
  @Input() public prefix: string;
  @Input() public items: [] = [];
  @Input() public selected: any;
  @Input() public placeholder: any;
  @Input() public formatGDB: boolean = false;
  @Input() public keepSearch: boolean = true;
  @Output() public changeValue: EventEmitter<any> = new EventEmitter();

  public _selected: any;
  public isOpen: boolean = false;
  public filter: any;
  public filterText: any;
  public filterContent: any;

  public ngOnInit() {
      if (this.items) {
          if (this.selected) {
              const tempSelected: any = this.items.find((item: any) => {
                return item.id === this.selected;
              });
              if (tempSelected) {
                this._selected = tempSelected;
              }
          }
      }
      this.prefix = "search-services-" + this.getRandomId();
  }

  public ngOnChanges(_changes: SimpleChanges): void {
      if (this.selected) {
          const tempSelected: any = this.items.find((item: any) => {
              return item.id === this.selected;
          });
          if (tempSelected) {
              this._selected = tempSelected;
          }
      } else {
          this._selected = null;
      }
  }

  public formatedGDB(item) {
    let formatedName = item.name;
    if (item.name?.startsWith("GDB")) {
        const parts = item.name.split("-");
        formatedName = `<span class="badge badge-light">${parts[0]}</span> `;
        formatedName += item.dbName ? item.dbName : ` ${this.formatName(item.name)} `;
        formatedName += ` ${this.formatVersion(item.name)}`;
        formatedName += `${this.formatSuffix(item.name)}`;
    }
    return formatedName;
  }

  public formatName(name) {
    const newName = name.slice(0, name.lastIndexOf("(")).replace("GDB", "");
    return ` ${newName.replace("-", " ")}`;
  }

  public formatSuffix(name) {
    const suffix = name ? name.split(")")[name.split(")").length - 1] : "";
    return ` ${suffix.replaceAll("-", " ")}`;
  }

  public formatVersion(version) {
    const endName = version.slice(version.lastIndexOf("("));
    const regExp = /\(([^)]+)\)/;
    const matches = regExp.exec(endName);
    return matches ? `<span class="badge badge-version">${matches[1]}</span>` : "";
  }

  public selectItem(item): void {
      this._selected = item;
      this.changeValue.emit(this._selected.id);
      this.clearFilter();
      this.unfocusInput();
  }

  public handleClick(event): void {
      if (event.target.id !== this.prefix && event.target.id !== "clearField" && this.isOpen) {
          this.unfocusInput();
          this.clearFilter();
      } else {
        if (this.isOpen && this._selected && event.target.id !== "clearField" && this.keepSearch) {
          this.filterText = this._selected?.dbName ? this._selected?.dbName : this._selected?.name;
          this.filterContent = this._selected?.id.split("(")[0];
          this.filter = { name: this.filterText };
        } else {
          this.clearFilter();
        }
      }
  }

  public focusInput(): void {
      this.isOpen = true;
      if (!this.keepSearch) {
        this.clearFilter();
      }
  }

  public unfocusInput(): void {
      this.isOpen = false;
  }

  public clearFilter(): void {
      this.filter = { name: "" };
      this.filterText = "";
      this.filterContent = "";
  }

  public filterChanged(value: any): void {
      this.filterContent = value;
      this.filter = { name: value };
  }

  public getRandomId() {
    const min = 1;
    const max = 100000;
    return Math.floor(Math.random() * (max - min)) + min;
  }
}
